import './index.scss'
import '../../assets/scripts/jQuery.positionSticky.min.js'
import LocomotiveScroll from 'locomotive-scroll'

let ismobile = $(window).width() > 767 ? true : false
let scroller

$(window).resize(function () {
  ismobile = $(window).width() > 767 ? true : false;
  // location.reload();
})

$(document).ready(function () {
  let head = ismobile ? $('.header').height() + 20 : $('.header').height();
  // 滑动 左侧固定 需要时打开
  // $('.section2 .us_cont .left_tab').positionSticky({offsetTop: head});
  // 切换表单
  $(document).on('click', '.section2 .left_tab .tab_t .tabs .tabs_item', function () {
    $(this).find('.ti').addClass('active')
    $(this).siblings('.tabs_item').find('.ti').removeClass('active');
    $('.section2 .right_form .form').eq($(this).index()).fadeIn().css('display', 'flex').siblings('.form').hide();
  })
  // 表单下拉
  var s_title = $(".form_i .r_i_set");
  var s_select = $(".se_i li");
  s_title.click(function (e) {
    $(this).addClass("span_aa");
    $(this).siblings("ul").slideDown();
    e.stopPropagation();
  });

  s_select.click(function () {
    var s_text = $(this).html();
    var s_title_2 = $(this).parent('ul').siblings(".r_i_set").children('span');
    s_title_2.html(s_text).removeClass("span_aa")
    $(this).parent('ul').siblings(".r_i_set").addClass("span_color")
    $(this).parent('ul').slideUp();
  });

  $(document).click(function () {
    s_title.removeClass("span_aa");
    $(".form_i ul").hide();
  });
})

